<template>
  <nx-onboarding-features-dialog
    :value="showDialog"
    :features="onboardingFeatures"
    @close="close"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import NxOnboardingFeaturesDialog from '@/modules/onboarding/components/OnboardingFeaturesDialog';

export default {
  name: 'nx-onboarding-manager',
  components: {
    NxOnboardingFeaturesDialog,
  },
  computed: {
    ...mapGetters('onboarding', ['onboardingFeatures', 'showDialog']),
    lastFeaturedViewed() {
      return this.profile.onboarding.lastFeaturedViewed;
    },
  },
  methods: {
    close() {
      this.$store.dispatch('onboarding/CLOSE_DIALOG');
    },
  },
};
</script>
